export default class LibraryBanner {

    constructor() {
        this.image = '';
        this.url = '';
        this.width = 0;
        this.height = 0;
        this.language = '';
    }

}